import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipmentCategories } from "@/features/equipments/hooks/useEquipmentCategories";
import { EquipmentCategoryData } from "@/features/equipments/types/equipments.type";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterEquipmentCategoryBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentCategoriesOptions,
  } = useEquipmentCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<EquipmentCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.EquipmentCategory}
      options={equipmentCategoriesOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEquipmentCategoryBadge;
